import { makeListState, makeDataState, STATUSES } from 'app/utils/redux';

import * as t from './types';

const initialState = {
  notices: makeListState(),
  notice: makeDataState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch notices
    case `${t.FETCH_NOTICES}_PENDING`:
      return {
        ...state,
        notices: {
          ...state.notices,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_NOTICES}_SUCCESS`:
      return {
        ...state,
        notices: {
          ...state.notices,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result,
        },
      };
    case `${t.FETCH_NOTICES}_ERROR`:
      return {
        ...state,
        notices: {
          ...state.notices,
          status: STATUSES.ERROR,
        },
      };

    case t.RESET_NOTICES:
      return {
        ...state,
        notices: makeListState(),
      };

    case `${t.FETCH_NOTICE}_PENDING`:
      return {
        ...state,
        notice: {
          ...state.notice,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_NOTICE}_SUCCESS`:
      return {
        ...state,
        notice: {
          ...state.notice,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: action.payload.result,
        },
      };
    case `${t.FETCH_NOTICE}_ERROR`:
      return {
        ...state,
        notice: {
          ...state.notice,
          status: STATUSES.ERROR,
        },
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/notices/reducer.js